import React, { useState, useRef } from 'react'
import styles from './Review.module.css'
import { useSelector } from 'react-redux'


import DialogExit from '../Stage/components/DialogExit/DialogExit'
import TopBar from '../Stage/components/TopBar/TopBar'
import { useHistory } from 'react-router-dom'
import IconVolume from '../../../assets/icons/IconVolume'
import { shuffledArray } from '../../../util/util'
import { getSoundDownloadUrl } from '../Stage/components/Sound/Sound'
import Image from '../Stage/components/Image/Image'
import IconFemale from '../../../assets/icons/IconFemale'
import IconMale from '../../../assets/icons/IconMale'

const CardWord = ({
    word,
    onCardClick,
    color,
}) => {
    return (
        <div
            onClick={onCardClick}
            className={styles.wordContainerReview}
            style={{backgroundColor: color}}>
            <div className={styles.wordContainerUpper}>
                <IconVolume size={24} className={styles.wordIconVolume}/>
                <Image
                    imagePath={word.img_path}
                    size={'100%'} />
                {
                    word.gender === 'Male' ? <IconMale size={24} className={styles.wordIconMale}/> :
                        word.gender === 'Female' ? <IconFemale size={24} className={styles.wordIconFemale}/> :
                            word.gender === 'Both' ?
                                <div style={{ display: 'flex', flexDirection: 'column',position: 'absolute', top: '8px', right: '8px' }}>
                                    <IconMale size={24} />
                                    <div style={{ height: '8px' }} />
                                    <IconFemale size={24} />
                                </div> :
                                <div style={{ width: '24px' }} />
                }
            </div>
            <p className={styles.wordHebrew} style={{color: 'white'}}>{word.vow}</p>
            <p className={styles.wordEnglish} style={{color: 'white'}}>{word.eng}</p>
        </div>
    )
}

const getWordsToReview = (words) => {
    const wordsToReview = []
    const a = shuffledArray(Object.keys(words)).slice(0, 20)
    for (let i = 0; i < a.length; i++) {
        wordsToReview[i] = words[a[i]]
    }
    return wordsToReview
}

const getWordsButtonIndexes = (currIndex, maxIndex) => {
    const a = [currIndex]
    let n = Math.round(Math.random() * maxIndex)
    while (a.includes(n)) n = Math.round(Math.random() * maxIndex)
    a[1] = n
    n = Math.round(Math.random() * maxIndex)
    while (a.includes(n)) n = Math.round(Math.random() * maxIndex)
    a[2] = n
    n = Math.round(Math.random() * maxIndex)
    while (a.includes(n)) n = Math.round(Math.random() * maxIndex)
    a[3] = n

    return shuffledArray(a)
}

const Review = ({

}) => {

    const wordsToReview = useRef(getWordsToReview(useSelector(state => state.words)))
    const isReviewedGood = useRef(Array(wordsToReview.current.length).fill(false))

    const history = useHistory();

    const [isDialogExitOpen, setIsDialogExitOpen] = useState(false)
    const [currIndex, setCurrIndex] = useState(0)
    const [wordsButtonIndexes, setWordsButtonIndexes] = useState(getWordsButtonIndexes(0, wordsToReview.current.length - 1))
    const [correctButton, setCorrectButton] = useState(false)
    const [selectedButton, setSelectedButton] = useState(-1)
    const [fadeOut, setFadeOut] = useState(false)
    const [doneScreen, setDoneScreen] = useState(false)

    const playSound = (soundPath) => {
        getSoundDownloadUrl(soundPath).then(url => {
            new Audio(url).play()
        })
    }

    const handleButtonClick = (index, word) => {
        setSelectedButton(index)
        if (word.vow === wordsToReview.current[currIndex].vow) {
            // Correct word
            setCorrectButton(true)
            isReviewedGood.current[currIndex] = true
            console.log(isReviewedGood.current);
        }
        else {
            setCorrectButton(false)
        }

        setTimeout(() => {
            setFadeOut(true)
        }, 500);

        setTimeout(() => {
            setFadeOut(false)
            setSelectedButton(-1)
            const newIndex = currIndex + 1;

            console.log(newIndex);
            if (newIndex >= wordsToReview.current.length) {
                console.log("here?");
                setDoneScreen(true)
            }
            else {
                setCurrIndex(newIndex)
                setWordsButtonIndexes(getWordsButtonIndexes(newIndex, wordsToReview.current.length - 1))
            }

        }, 1000);
    }

    let content = null

    if (doneScreen) {
        content = <div
            className={styles.doneContainer}>
            {wordsToReview.current.map((word,index) => {
                return <CardWord
                    color={isReviewedGood.current[index] ? '#26C281' : '#FF6464'}
                    word={word}
                    onCardClick={() => playSound(word.sound_path)} />
            })}
        </div>;
    }
    else {
        content = <div
            className={styles.innerContainer}
            style={{ opacity: fadeOut ? 0 : 1 }}>
            <div
                onClick={() => playSound(wordsToReview.current[currIndex].sound_path)}
                className={styles.wordContainer}
                style={{ /* opacity: switchTransition || fadeOut ? 0 : 1  */ }}>
                <IconVolume
                    size={24}
                    className={styles.volumeIcon} />
                <p
                    className={styles.wordTitle}>
                    {wordsToReview.current[currIndex].vow}
                </p>



            </div>

            <div
                className={styles.buttonsContainer}>
                <p
                    onClick={selectedButton !== -1 ? null : () => handleButtonClick(0, wordsToReview.current[wordsButtonIndexes[0]])}
                    className={styles.button}
                    style={selectedButton === 0 ? { backgroundColor: correctButton ? '#26C281' : '#FF6464', color: 'white' } : {}}>{wordsToReview.current[wordsButtonIndexes[0]].eng}</p>
                <p
                    onClick={selectedButton !== -1 ? null : () => handleButtonClick(1, wordsToReview.current[wordsButtonIndexes[1]])}
                    className={styles.button}
                    style={selectedButton === 1 ? { backgroundColor: correctButton ? '#26C281' : '#FF6464', color: 'white' } : {}}>{wordsToReview.current[wordsButtonIndexes[1]].eng}</p>
                <p
                    onClick={selectedButton !== -1 ? null : () => handleButtonClick(2, wordsToReview.current[wordsButtonIndexes[2]])}
                    className={styles.button}
                    style={selectedButton === 2 ? { backgroundColor: correctButton ? '#26C281' : '#FF6464', color: 'white' } : {}}>{wordsToReview.current[wordsButtonIndexes[2]].eng}</p>
                <p
                    onClick={selectedButton !== -1 ? null : () => handleButtonClick(3, wordsToReview.current[wordsButtonIndexes[3]])}
                    className={styles.button}
                    style={selectedButton === 3 ? { backgroundColor: correctButton ? '#26C281' : '#FF6464', color: 'white' } : {}}>{wordsToReview.current[wordsButtonIndexes[3]].eng}</p>
            </div>
        </div>
    }

    return (
        <div
            className={styles.container}>
            <DialogExit
                open={isDialogExitOpen}
                onCancel={() => setIsDialogExitOpen(false)}
                onExit={() => history.goBack()} />
            <TopBar
                progress={currIndex}
                maxProgress={wordsToReview.current.length}
                onClose={() => setIsDialogExitOpen(true)} />
            <div style={{ height: '80px' }} />

            {content}
        </div>
    )
}

export default Review
